import { useTheme } from "../../hooks/useTheme";
import logoDark from "../../oversight-core/assets/images/logo-dark.svg";
import logo from "../../oversight-core/assets/images/logo.svg";

const Logo = () => {
  const theme = useTheme();
  return <img src={theme === "dark" ? logoDark : logo} alt="oversight_logo" />;
};

export default Logo;
